import { ReactNode } from 'react';

interface ModalProps {
    title: string;
    size?: string;
    onClose: () => void;
    children?: ReactNode; // 방법 1: children prop 사용
    footer?: ReactNode; // 방법 2: 커스텀 footer
    hideFooter?: boolean; // footer 숨김 옵션
}

const Modal = ({
    title = '안내',
    size = 'lg',
    onClose,
    children,
    footer,
    hideFooter = false,
}: ModalProps) => {
    // 기본 footer 렌더링
    const renderFooter = () => {
        if (hideFooter) return null;

        if (footer) {
            return <div className="modal-footer">{footer}</div>;
        }

        // 기본 footer
        return (
            <div className="modal-footer">
                <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn-wave undefined btn btn-outline-secondary"
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        );
    };

    return (
        <>
            <div className="fade modal-backdrop show"></div>
            <div
                className="fade popover-modal modal show"
                style={{ display: 'block', paddingRight: '0px' }}
                onClick={onClose}
            >
                <div
                    id="exampleModalScrollable4"
                    data-bs-keyboard="false"
                    className={`modal-dialog modal-${size} modal-dialog-centered`}
                >
                    <div
                        className="modal-content"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="modal-header">
                            <h6
                                className="modal-title"
                                id="staticBackdropLabel4"
                            >
                                {title}
                            </h6>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">{children || '내용'}</div>
                        {renderFooter()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
